import api from './api.js'

export const getVehicles = (page = 0, size = 20, filters = {}) => {
  const params = { page, size, ...filters }
  // Remove empty/null values
  Object.keys(params).forEach(key => {
    if (params[key] === '' || params[key] === null || params[key] === undefined) {
      delete params[key]
    }
  })
  return api.get('/admin/v1/vehicles', { params })
}

export const getVehicleById = (id) => api.get(`/admin/v1/vehicles/${id}`)

export const updateVehicle = (id, data) => api.patch(`/admin/v1/vehicles/${id}`, data)

export const getVehicleStats = () => api.get('/admin/v1/vehicles/stats')

export const createVehicle = (data) => api.post('/admin/v1/vehicles', data)

export const addOwner = (vehicleUuid, data) => api.post(`/admin/v1/vehicles/${vehicleUuid}/owners`, data)

export const removeOwner = (vehicleUuid, userUuid) => api.delete(`/admin/v1/vehicles/${vehicleUuid}/owners/${userUuid}`)

export const updateOwnership = (vehicleUuid, userUuid, data) => api.patch(`/admin/v1/vehicles/${vehicleUuid}/owners/${userUuid}`, data)

export const getVesCache = (plate) => api.get(`/admin/v1/enrichment/ves-cache/${encodeURIComponent(plate)}`)

export const getVesCacheStats = () => api.get('/admin/v1/enrichment/ves-cache/stats')

export const getRapidCarCheckCache = (plate) => api.get(`/admin/v1/enrichment/rapidcarcheck-cache/${encodeURIComponent(plate)}`)

export const getRapidCarCheckCacheStats = () => api.get('/admin/v1/enrichment/rapidcarcheck-cache/stats')

export const forceEnrichment = (vehicleUuid) => api.post(`/admin/v1/vehicles/${vehicleUuid}/enrich`)

export const getMotHistory = (plate) => api.get(`/admin/v1/enrichment/mot-history/${encodeURIComponent(plate)}`)
